function useAdminApi() {
    async function endpoint(path) {
        return `/api/admin/${path}`;
    }

    async function request(path, options) {
        const response = await fetch(await endpoint(path), options);

        return {
            response: response,
            ok: response.ok,
            data: response.bodyUsed ? null : await response.json(),
        };
    }

    request.post = function post(path, body = {}) {
        return request(path, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
    };

    request.patch = function patch(path, body = {}) {
        return request(path, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
    };

    request.put = function put(path, body = {}) {
        return request(path, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
    };

    request.delete = function del(path, body = {}) {
        return request(path, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
    };

    return {
        endpoint,
        request,
    };
}

export default useAdminApi;
